<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
  }>(),
  {
    title:
      'Dipercaya, Melayani kebutuhan logistik berbagai skala <br class="hidden lg:inline" /> mulai dari UMKM hingga perusahaan nasional.'
  }
)

const clients = [
  {
    name: 'Aerostreet',
    icon: 'ka-icon:aerostreet'
  },
  {
    name: 'Jilbrave',
    icon: 'ka-icon:jilbrave',
    class: 'text-[#A56C65]'
  },
  {
    name: 'Natasha',
    icon: 'ka-icon:natasha',
    class: 'text-[#84641C]'
  },
  {
    name: 'Paragon Corp',
    icon: 'ka-icon:paragon'
  },
  {
    name: 'Finna Food',
    icon: 'ka-icon:finna',
    class: 'text-[#EB5A2E]'
  },
  {
    name: 'Plugo',
    icon: 'ka-icon:plugo'
  },
  {
    name: 'Cover Super',
    icon: 'ka-icon:cover-super'
  },
  {
    name: 'Clandys',
    icon: 'ka-icon:clandys'
  },
  {
    name: 'Nashir',
    icon: 'ka-icon:nashir'
  },
  {
    name: 'Skinmology',
    icon: 'ka-icon:skinmology'
  },
  {
    name: 'Starcomp',
    icon: 'ka-icon:starcomp'
  },
  {
    name: 'Djatsai',
    icon: 'ka-icon:djatsai'
  },
  {
    name: 'Maestro Parfum',
    icon: 'ka-icon:maestro'
  },
  {
    name: 'Lurik Prasojo',
    icon: 'ka-icon:prasojo'
  }
]
</script>
<template>
  <section class="py-6 lg:py-16">
    <div class="mx-auto">
      <UiContainer class="mb-3 lg:mb-12 text-center">
        <UiSectionTitle variant-size="small" :title="title" />
      </UiContainer>
      <div class="relative overflow-hidden">
        <UiLogoLoop
          :logos="clients"
          :speed="50"
          direction="left"
          :logo-height="80"
          :gap="10"
          :pause-on-hover="true"
          :scale-on-hover="true"
          :fade-out="true"
          fade-out-color="#ffffff"
          aria-label="Technology partners"
        />
      </div>
    </div>
  </section>
</template>
